// extracted by mini-css-extract-plugin
export var menuItem = "D_v3 d_fY d_by d_bC d_bN d_bd";
export var menuItemSub = "D_v4 d_Y d_by d_bN";
export var menuMainLink = "D_v5 d_fZ d_dz";
export var menuLink = "D_v6 d_fZ d_dz";
export var icon = "D_pC d_bB d_bN";
export var divider = "D_v7 d_bB d_bN";
export var sublinks = "D_v8";
export var link = "D_mB";
export var Link = "D_rs q_rs q_qK q_q3";